const rates = {
  createRateBtn: 'Criar',
  showBreakdownBtn: 'Mostrar detalhamento',
  total: 'Total: ',

  table: {
    headers: {
      name: 'Nome',
      code: 'Código',
      supplierName: 'Fornecedor',
      isActive: 'Status',
      isAvailable: 'Disponível',
      biDir: 'Bidirecional',
    },
    filters: {
      code: 'Código',
      supplier: 'Fornecedor',
      profile: 'Perfil',
      attributes: 'Atributos',
      service: 'Serviço',
    },
    cells: {
      isActive: {
        true: 'Ativo',
        false: 'Inativo',
      },
      isAvailable: {
        true: 'SIM',
        false: 'NÃO',
      },
    },
    biDirOptions: {
      way2: '2 Vias',
      way1: 'Só ida',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
  },

  deleteModal: {
    header: 'Excluir Taxas',
    body: 'Você está prestes a excluir as taxas {{num}}.',
  },

  rateTypeOptions: {
    Base: 'Base',
    Addition: 'Adição',
    Percent: 'Porcentagem',
    Total: 'Total',
  },

  additions: {
    value: 'Valor',
    valueType: 'Tipo do Valor',
    name: 'Nome',
    hour1: 'Horário de início',
    hour2: 'Horário final',
    date1: 'Data de início',
    date2: 'Data de término',
    cancel: 'Cancelar',
    addAddition: 'Adicionar Adição',
    priority: 'Prioridade',
    weekDays: 'Dias da Semana',
    newAddition: 'Nova adição',
    price: 'Preço',
    total: 'Total',
    percent: 'Porcentagem',
    columnExist: 'O título já existe',
  },

  toast: {
    error: {
      badResponse: '[localização] resposta inválida do servidor',
    },
  },

  create: {
    successToast: {
      message: 'sucesso! Taxa criada',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar a taxa',
    },
  },

  edit: {
    successToast: {
      message: 'sucesso! Taxa de atualização',
    },

    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar a taxa',
    },

    modalError: {
      header: 'Erro.',
      body: 'Não é possível atualizar a taxa.',
    },
  },

  delete: {
    successToast: {
      message: '[Rates] excluídas com sucesso',
    },

    errorToast: {
      message: 'resposta inválida do servidor',
    },
  },

  forms: {
    header: {
      createRate: {
        title: 'Criar',
      },

      updateRate: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalhes da Tarifa',
        fields: {
          units: {
            name: 'Sites',
          },
          from: {
            name: 'From',
          },
          to: {
            name: 'To',
          },
          supplierId: {
            name: 'Fornecedor',
          },
          servicesIds: {
            name: 'Serviço',
          },
          profilesIds: {
            name: 'Perfil',
          },
          attributesIds: {
            name: 'Atributo',
          },
          biDirectional: {
            name: 'Bidirecional',
          },
          group: {
            name: 'Rate Group',
          },
          name: {
            name: 'Nome',
          },
        },
      },
    },
    type: {
      header: 'Rate Type',
      fields: {
        fromAreasIds: 'Da zona',
        toAreasIds: 'Para zona',
        biDirectional: 'Bidirecional',
        basePrice: 'Preço Base',
        durationFactors: {
          baseDuration: 'Duração Base',
          pricePerAdditional: {
            value: 'Por Minuto Adicional',
            type: {
              fixed: 'Fixo',
              percentage: 'Porcentagem (Do Base)',
            },
          },
        },
        distanceFactors: {
          baseDistance: 'Distância Base',
          pricePerAdditional: {
            value: 'Por KM/Milha Adicional',
            type: {
              fixed: 'Fixo',
              percentage: 'Porcentagem (Do Base)',
            },
          },
        },
      },
      addBtn: 'Adicionar',
    },
    availability: {
      header: 'Disponibilidade de Tarifa',
      fields: {
        from: 'Disponível a Partir de',
        to: 'Disponível Até',
        fromTime: 'Hora Inicial',
        toTime: 'Hora Final',
        weekDays: 'Dias da Semana',
      },
      addBtn: 'Adicionar Disponibilidade',
    },

    addition: {
      header: 'Adições Gerais',
      fields: {
        stops: {
          included: 'Paradas Incluídas',
          pricePerAddition: {
            value: 'Por Parada Adicional',
            type: {
              fixed: 'Fixo',
              percentage: 'Percentagem (Do Base)',
            },
          },
        },
        seats: {
          included: 'Assentos Incluídos',
          pricePerAddition: {
            value: 'Por Assento Adicional',
            type: {
              fixed: 'Fixo',
              percentage: 'Percentagem (Do Base)',
            },
          },
        },
      },
    },
    peakHoursSurcharge: {
      header: 'Taxa Adicional para Horários de Pico',
      fields: {
        name: 'Nome',
        fromTime: 'De',
        toTime: 'Para',
        priceAddition: {
          value: 'Adição de Preço',
          type: {
            fixed: 'Fixo',
            percentage: 'Percentagem (Do Base)',
          },
        },
        weekDays: 'Dias da Semana',
      },
      addBtn: 'Adicionar Taxa para Horários de Pico',
    },

    geoAdditions: {
      generalAreaEntrance: {
        header: 'Entrada Geral na Zona',
        fields: {
          pricePerArea: 'Preço por Zona',
          chargingMethod: {
            name: 'Método de Cobrança',
            options: {
              drivingThrough: 'Passando pela Zona',
              stops: 'Paradas',
            },
          },
          type: {
            fixed: 'Fixo',
            percentage: 'Percentagem (Do Base)',
          },
        },
      },
      specificAreaEntrance: {
        header: 'Entrada em Zona Específica',
        fields: {
          areasIds: 'Zona',
          pricePerArea: 'Preço por Zona',
          chargingMethod: {
            name: 'Método de Cobrança',
            options: {
              drivingThrough: 'Passando pela Zona',
              stops: 'Paradas',
            },
          },
          type: {
            fixed: 'Fixo',
            percentage: 'Percentagem (Do Base)',
          },
        },
        addBtn: 'Adicionar Zona',
      },
    },
  },
};

export default rates;
